import apiClient from '@/services/axios'

export const getAllUser = async (username, customerId) => {
  // console.log(username)
  const res = await apiClient.get('/admin/users', { params: { username, customerId } })
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getAllSiteManagers = async username => {
  console.log(username)
  const res = await apiClient.get('/admin/site-managers', { params: { username } })
  if (res) {
    return res.data
  } else {
    return []
  }
}
